/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_ReportService_Dtos_AuditTrailsDto } from '../models/Wealthlane_ReportService_Dtos_AuditTrailsDto';
import type { Wealthlane_ReportService_Dtos_AuditTrailsSummaryResponseDto } from '../models/Wealthlane_ReportService_Dtos_AuditTrailsSummaryResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DashboardService {

    /**
     * @returns Wealthlane_ReportService_Dtos_AuditTrailsDto Success
     * @throws ApiError
     */
    public static getApiReportApiAppDashboardParticipantDashboard(): CancelablePromise<Array<Wealthlane_ReportService_Dtos_AuditTrailsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/report/api/app/dashboard/participant-dashboard',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @returns Wealthlane_ReportService_Dtos_AuditTrailsSummaryResponseDto Success
     * @throws ApiError
     */
    public static getApiReportApiAppDashboardParticipantDashboardSummary(): CancelablePromise<Wealthlane_ReportService_Dtos_AuditTrailsSummaryResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/report/api/app/dashboard/participant-dashboard-summary',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

}
